<template>
    <el-dialog v-model="view" title="新增/编辑角色" width="20%" :before-close="handleClose">
        <el-form class="TTL-from-center">
            <el-form-item>
            <div class="TTL-input TTL-form-input width300">
            <el-input v-model="roleparam.rolename" placeholder="角色名称" clearable />
            </div>
            </el-form-item>
            <el-form-item>
            <div class="TTL-button">
            <el-button @click="SubmitData">提交</el-button>
            </div> 
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import INTERFACE_MODEL_MANAGER from '@/Interface/manager/manager';
export default {
    props:['value','id','rolename'],
    components:{},
    data() {
        return {
            view:false,
            roleparam: {
                id:'',
                rolename:'',
            },
        }
    },
    mounted() {
        
    },
    watch: {
        value(val) {
            if(!val) return false;
            var _this=this;
            this.view=true;
            this.resetData();
        }
    },
    methods: {


        /** 新增/编辑角色信息 **/
        SubmitData() {
            if(this.roleparam.rolename=='') {this.$notice({title:'错误提示',message:'角色名称不能为空',type:'warning'});return false;}
            INTERFACE_MODEL_MANAGER.ADD_OR_EDIT_ROLE(this.roleparam).then((res) => {
                 if(res.status > 0) return false;
                 this.view=false;
                 this.handleClose();
            });
        },

        
        /** 重置参数 **/
        resetData() {
            this.roleparam.id=this.id;
            this.roleparam.rolename=this.rolename;
        },

        /** 关闭前操作 **/
        handleClose() {
            this.$emit('AddOrEditRollback');
            this.view=false;
        },

    },
}
</script>
<style scoped>

</style>